<div style="width: 100%; height: 100%">
  <ag-grid-angular
    class="ag-bcdfx"
    #rungGrid
    style="height: 100%"
    enableColResize
    enableSorting
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [showToolPanel]="false"
  >
  </ag-grid-angular>
</div>
